import Styles from './Carousels.module.scss'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'
import { useRef } from 'react'
import { CheckboxChecked } from 'blaze-ui/icons'
import { useMediaPickerContext } from '../MediaPickerContext'

type Props = {
  src: string
  file: IMediaFile
  onPress: () => void
  'aria-label'?: string
}

export const MediaFile = ({ src, file, onPress, ...rest }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const { buttonProps } = useButtonWithScrollCancel({ onPress, elementType: 'div' }, ref)

  const { isFileSelected } = useMediaPickerContext()
  const isSelected = isFileSelected(file)

  return (
    <div {...buttonProps} {...rest} className={Styles.mediaFileThumbnail}>
      <img src={src} alt={file.title} />
      {file.duration && file.duration > 0 && <VideoDuration duration={file.duration} />}
      {isSelected && (
        <div className={Styles.selectionIndicator}>
          <CheckboxChecked size={20} color="#1F75FF" />
        </div>
      )}
    </div>
  )
}
